import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ArrowBack } from "@mui/icons-material";

export const GoBack = () => {
  const history = useHistory();

  return (
    <div
      onClick={history.goBack}
      className="relative z-10 px-6 pt-14 pb-6 flex items-center gap-3"
    >
      <button
        type="button"
        className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm text-[#1a4bdf] transition-transform active:scale-95"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <span className="text-[#1a4bdf] font-medium text-[17px]">Back</span>
    </div>
  );
};
